import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getWalletTemplatesForGroup = groupId =>
  call(websocketFetch, 'get_wallet_templates_for_group', { group_id: groupId });
